import React from 'react';
import { Button, Container } from 'reactstrap';
// import { t } from 'i18next';
import ReactToPrint from 'react-to-print';
import A5ENPrintComponent from './a5_en_print_component';
function PrintButton({ selectedData }) {
  const a5Ref = React.useRef();
  const pageStyle = `
    @page {
      size: A5 landscape;
    }
  `;
  return (
    <>
      <ReactToPrint
        pageStyle={pageStyle}
        documentTitle={selectedData?.waybillnumber}
        trigger={() => {
          return (
            <Button
              style={{ width: 120, height: 90, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              size='sm'
              onClick={() => {}}
            >
              <i className='fa fa-file-archive mr-2' style={{ fontSize: '80px' }} />
              {/* {t('print')} */}
            </Button>
          );
        }}
        content={() => {
          return a5Ref.current;
        }}
      />

      <Container fluid style={{ display: 'none' }}>
        <A5ENPrintComponent data={selectedData} ref={a5Ref} />
      </Container>
    </>
  );
}

export default PrintButton;
